import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from './useUniversalNavContext';
export const prepareSessionData = (json) => {
    var _a, _b, _c;
    const currentRole = (_b = (_a = json.roles) === null || _a === void 0 ? void 0 : _a.find((role) => {
        return role.account_id === json.current_account_id;
    })) === null || _b === void 0 ? void 0 : _b.role;
    const output = {
        customUserId: json.id,
        bannerMessage: json.banner_message,
        currentAccountId: json.current_account_id,
        isLoggedIn: json.is_logged_in,
        isStaff: json.is_staff,
        email: json.email,
        currentUserRole: currentRole,
        hasSeenNotifications: {
            jobsCta: (_c = json.has_seen_notifications) === null || _c === void 0 ? void 0 : _c.jobs_cta,
        },
    };
    return output;
};
async function fetchSessionData(apiHostname) {
    const response = await fetch(`${apiHostname}/api/v4/session`, {
        credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const json = await response.json();
    return prepareSessionData(json);
}
export const SESSION_QUERY_KEY = ['session'];
export const useQuerySession = (sessionData, apiHostnameFromParams) => {
    const { sessionData: sessionDataFromProps, apiHostname: apiHostnameFromContext, } = useUniversalNavContext();
    const apiHostname = apiHostnameFromParams || apiHostnameFromContext;
    const result = useQuery({
        queryKey: SESSION_QUERY_KEY,
        queryFn: () => fetchSessionData(apiHostname),
        enabled: !sessionDataFromProps && !sessionData,
        initialData: sessionDataFromProps || sessionData,
        staleTime: 1000 * 10,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQuerySession.js.map
// @zapier/universal-layout@11.0.80 (863ea7570)
